import { useEffect, useState } from 'react';
import { msaApi } from '../lib/apiClient.js';

export default function useUniverseSummary() {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    let alive = true;
    msaApi.universeSummary()
      .then((value) => { if (alive) setSummary(value); })
      .catch(() => { if (alive) setSummary(null); });
    return () => { alive = false; };
  }, []);

  return summary;
}
